import { render, staticRenderFns } from "./activityInfo.vue?vue&type=template&id=48ffcd68&scoped=true"
import script from "./activityInfo.vue?vue&type=script&lang=js"
export * from "./activityInfo.vue?vue&type=script&lang=js"
import style0 from "./activityInfo.vue?vue&type=style&index=0&id=48ffcd68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ffcd68",
  null
  
)

export default component.exports